var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterdOkasBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 30.608,
    viewBox: "0 0 37 30.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9934",
    "data-name": "Group 9934",
    transform: "translate(18786.5 2454.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    className: "cls-1",
    d: "M65.132,48.907a1.094,1.094,0,1,0,.773.32A1.087,1.087,0,0,0,65.132,48.907Z",
    transform: "translate(-18821.352 -2483.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    className: "cls-1",
    d: "M65.132,48.907a1.094,1.094,0,1,0,.773.32A1.087,1.087,0,0,0,65.132,48.907Z",
    transform: "translate(-18827.914 -2483.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    className: "cls-1",
    d: "M65.132,48.907a1.094,1.094,0,1,0,.773.32A1.087,1.087,0,0,0,65.132,48.907Z",
    transform: "translate(-18834.477 -2483.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    className: "cls-2",
    d: "M-21048.227-23996.766v2.344",
    transform: "translate(2271.824 21561.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    className: "cls-2",
    d: "M-21048.227-23996.766v2.344",
    transform: "translate(2267.449 21561.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    className: "cls-1",
    d: "M-22637-21396.557l5.623-10.713h22.256l5.621,10.713",
    transform: "translate(3852.25 18954.268)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1826",
    "data-name": "Ellipse 1826",
    className: "cls-3",
    cx: 2.75,
    cy: 2.75,
    r: 2.75,
    transform: "translate(-18770.75 -2428.895)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9933",
    "data-name": "Group 9933",
    transform: "translate(-18785.5 -2442.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    className: "cls-2",
    d: "M22.709,16.071H34A1.038,1.038,0,0,0,35,15V1.071A1.038,1.038,0,0,0,34,0H1A1.038,1.038,0,0,0,0,1.071V15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    className: "cls-2",
    d: "M12.292,16.071H1A1.038,1.038,0,0,1,0,15V1.071A1.038,1.038,0,0,1,1,0H34a1.038,1.038,0,0,1,1,1.071V15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterdOkasBoxes);
export default __webpack_public_path__ + "static/media/RegisterdOkasBoxes.358505f574d5c34b8bca1276d8fda0d5.svg";
export { ForwardRef as ReactComponent };